import { render, staticRenderFns } from "./dashboard-therm.vue?vue&type=template&id=5d483a78&scoped=true"
import script from "./dashboard-therm.vue?vue&type=script&lang=js"
export * from "./dashboard-therm.vue?vue&type=script&lang=js"
import style0 from "./dashboard-therm.vue?vue&type=style&index=0&id=5d483a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d483a78",
  null
  
)

export default component.exports